/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/document/DocumentScannerGuidanceVisibility.yaml
/** @hidden */
export const UserGuidanceVisibilityValues = [
    'ENABLED',
    'AUTO_CAPTURE_ONLY',
    'DISABLED',
];
//# sourceMappingURL=DocumentScannerGuidanceVisibility.js.map